import { NgModule } from '@angular/core';
import { FunFactsModalComponent } from './fun-facts-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from './../../../shared/shared.module';

@NgModule({
  declarations: [
    FunFactsModalComponent
  ],
  imports: [
    MatDialogModule,
    SharedModule
  ],
  entryComponents: [FunFactsModalComponent]
})
export class FunFactsModalModule { }
